export default function Numbers({ numbers }) {
  return (
    <section className="container px-4 mx-auto w-full">
      <div className="flex justify-center">
        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 font-['Inter']">
          {numbers.map(({ number, title }) => (
            <div
              tabIndex={0}
              key={number}
              className="flex flex-col items-center py-8 lg:py-4"
            >
              <h2 className="text-maingray text-5xl font-bold mb-3">
                {number}
              </h2>
              <p className="text-secgray font-semibold">{title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
